import { useMutation } from "@tanstack/react-query";
import Axios from "Services/Auth/AxiosInterceptors";

/**
 * Converts updatedProvider object into required API payload:
 * {
 *   updates: [
 *     { id, enableNotes?, enableSkipChat?, active? }
 *   ]
 * }
 */
const buildBulkTogglePayload = (updatedProvider) => {
  const updates = Object.keys(updatedProvider).map((id) => {
    const provider = updatedProvider[id];
    const updateObj = { id };

    if (provider.enableNotes !== undefined) updateObj.enableNotes = provider.enableNotes;
    if (provider.enableSkipChat !== undefined) updateObj.enableSkipChat = provider.enableSkipChat;
    if (provider.enabledVisitTypes !== undefined) updateObj.enabledVisitTypes = provider.enabledVisitTypes;
    if (provider.active !== undefined) updateObj.active = provider.active;

    return updateObj;
  });

  return { updates };
};

const bulkToggleAPI = async (updatedProvider) => {
  try {
    const payload = buildBulkTogglePayload(updatedProvider);

    const response = await Axios.patch("/doctor-access/doctor/access-levels/bulk-toggle", payload);

    const data = response.data;

    return data;
  } catch (error) {
    const backendError = error?.response?.data?.errors?.[0] || error?.response?.data?.message || error?.message;

    throw new Error(backendError || "Oops Something went wrong. Please try again later.");
  }
};

/**
 * Custom hook for bulk toggle mutation
 */

export const useBulkToggleAccessLevels = (onSuccess = () => {}, onError = () => {}) => {
  return useMutation({
    mutationFn: bulkToggleAPI,
    onSuccess,
    onError,
  });
};
